import { render, staticRenderFns } from "./VtuAccount.vue?vue&type=template&id=6e9ffbe0"
import script from "./VtuAccount.vue?vue&type=script&lang=js"
export * from "./VtuAccount.vue?vue&type=script&lang=js"
import style0 from "./VtuAccount.vue?vue&type=style&index=0&id=6e9ffbe0&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports